module.exports = __webpack_public_path__ + "assets/img/dzh-21.a0488298.jpg";